import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography } from "@material-ui/core";
import StrategyName from "../../../../../components/client/StrategyName";
import InfoIcon from "@material-ui/icons/Info";
import NumberFormat from "react-number-format";
import { useActions } from "../../../../../actions";
import * as Actions from "../../../../../actions/estimation";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import { allocationQuestions, isALGCarrier } from "../../utils/utils";
import {getCarrierCode, isDebug} from "../../../../../utils/commonUtils";
import * as CActions from "../../../../../actions/client";
import * as EstimatorActions from "../../../../../actions/estimator";
import { useGwtV2 } from "../../../../../hooks/isGwtV2";
import { useGetRecipientPageProps } from "../../../../../model/PageProps";
import { CallingFromObject } from "../../../../../constants";

function Assumptions(props: any) {
    const {strategyName, common , callingFrom= "ESTIMATOR", tag="", clientData } = props;
    const debugMode = isDebug();

    let growthRate:number = ((common && common.growthrate)*100) || 0;
    let incometaxrate:number = ((common && common.incometaxrate)*100) || 0;
    let { user: { id }, user } =  useSelector((state: RootState) => state.auth);
    const [investType, setInvestType] = React.useState()
    const clientPolicy = user.client && user.client.clientPolicies && user.client.clientPolicies[0] || clientData && clientData.clientPolicies && clientData.clientPolicies[0];
    const carrierId = user.accessType === "client" ? user.demoCarrierId : (clientPolicy && clientPolicy.carrier ? clientPolicy.carrier.id : undefined);
    const strategyId = user.accessType === "client" ? user.demoStrategyId : (clientPolicy && clientPolicy.strategy ? clientPolicy.strategy.id : undefined);
    const clientId = user.accessType === "client" ? user.demoClientId : (user.client && user.client.id || clientData && clientData.id);
    const [clientAllocations, setClientAllocations] = React.useState({});
    const [estimatorDataId, setEstimatorDataId] = React.useState<any | null>();
    const [estimatedDetails, setEstimatedDetails] = React.useState<any | null>();
    let capitalgainstaxrate:number = ((common && common.capitalgainstaxrate)*100) || 0;
    const [allocationQuestion, setAllocationQuestion] = useState({});
    const estimatorActions = useActions(EstimatorActions);
    const clientActions = useActions(CActions);
    const isAlZ =  getCarrierCode(carrierId || 2) == "ALZ"
    const estimationActions = useActions(Actions);
    const clientInvestment:any = user && user.client && user.client.clientInvestmentType;
    const tempUserId = useGetRecipientPageProps("userId")
    const tempClientPolicyId = useGetRecipientPageProps("clientPolicyId")
    const isDemo = user.accessType === "client";
    const getEstimatorDataFromApi = async (query: Partial<{ strategyId: number, carrierId: number }>) => {
        if (query.carrierId && query.strategyId) {
            const res = await estimatorActions.getEstimatorDetails(query);
            if (!!res) {
                setEstimatorDataId(res.id);
            }
        }
    }
    debugMode && console.log(tempUserId, "=== tempClientPolicyId", tempClientPolicyId)
    React.useEffect(()=>{
        (async ()=>{
            if(isDemo || callingFrom == CallingFromObject.GIFTOR_RECIPIENT){
                const userId = callingFrom == CallingFromObject.GIFTOR_RECIPIENT ?  tempUserId : id;
                const clientPolicyId = callingFrom == CallingFromObject.GIFTOR_RECIPIENT ?  tempClientPolicyId : clientPolicy && clientPolicy.id;
                let estimationDetails: any = await estimationActions.getEstimationDetailsByUserId(userId, callingFrom, clientPolicyId);
                if(estimationDetails){
                    setEstimatedDetails(estimationDetails)
                    setInvestType(estimationDetails.InvestmentType)
                }
            }
        })()
    },[])

    React.useEffect(() => {
        (async () => {
            if (estimatorDataId) {
                const res = await estimationActions.getAllocationQuestions({ estimatorId: estimatorDataId, carrierId:carrierId });
                if (res) {
                    const values = {};
                    res.forEach((fields) => {
                        values[fields.code] = fields;
                    });
                    setAllocationQuestion(values);
                }
            }
        })();

    }, [estimatorDataId]);

    React.useEffect(() => {
        if(strategyId && carrierId){
            let query: Partial<{ strategyId: number, carrierId: number }> = {};
            query = {
                strategyId: strategyId,
                carrierId: carrierId,
            };

            getEstimatorDataFromApi(query).then(() => {
            });

        }
    }, [strategyId, carrierId]);


    React.useEffect(()=>{
        (async ()=>{
            // TO PREVENT API HIT IN CASE OF ADMIN_FINAL_ILLUSTRATION
            if(callingFrom == "ADMIN_FINAL_ILLUSTRATION" && !(clientId) ){
                return
            }
            // IN DEMO MODE NO NEED TO HIT API
            if(user.accessType === "client"){
                return
            }
            if (clientId) {
                const response = await clientActions.getClientAllocations({ clientId: clientId });
                if (response && Array.isArray(response)) {
                    const data = {};
                    response.forEach((clientAllocation) => {
                        if (clientAllocation.percentage) {
                            data[clientAllocation.questionCode] = clientAllocation;
                        }
                    });
                    setClientAllocations(data);
                }
            }
        })()
    },[clientId])
   const getAllocationFromStressRequest = () => {
    const stressRequest = estimatedDetails && JSON.parse(estimatedDetails.stressRequest)
     if(stressRequest && stressRequest.illustration && stressRequest.illustration.interestrates[0].allocations){
         debugMode && console.log(stressRequest.illustration.interestrates[0].allocations, "=== stressRequest.illustration.interestrates[0].allocations")
         const questionLabels = stressRequest.illustration.interestrates[0].allocations.map(({allocationname})=>{
             debugMode && console.log(allocationQuestion[allocationname], "=== allocationQuestion[allocationname]", allocationQuestion)
             return  allocationQuestion[allocationname] && allocationQuestion[allocationname].label
         })
         return questionLabels
     }
     return []
    }
    const getAllocationQuestionForClient = () =>{
        if(isDemo) {
            return  allocationQuestions[investType] && allocationQuestions[investType].labels || []
        }
        // if client made through new invitation and allocations exist in db
        const questionLabels = Object.keys(clientAllocations).map((code)=>{
           return  allocationQuestion[code] && allocationQuestion[code].label
        })
        // for old client it will work as before
        return  questionLabels.length > 0 ? questionLabels : []
    }

    const getQuickEstimationAllocationQuestions = () =>{
        if(isAlZ) {
          return  allocationQuestions["Conservative"].labels
        }
        return  allocationQuestions["lowVolatility"].labels
    }
    const  getAllocations = () => {
        switch(tag) {
            case "QUICK-ESTIMATION":
                // made quick estimation dynamic according carrier
                     return  <>{getQuickEstimationAllocationQuestions().join(", ")} (Illustrated Growth Rate: <NumberFormat
                             value={growthRate}
                             displayType={"text"}
                             decimalScale={2}
                             thousandSeparator={false}
                             suffix={"%"}/>)</>
            default:
                    return <>{(isDemo || callingFrom == CallingFromObject.GIFTOR_RECIPIENT) ? getAllocationFromStressRequest().join(", ") : getAllocationQuestionForClient().join(", ")}
                        (Illustrated Growth Rate: <NumberFormat
                        value={growthRate}
                        displayType={"text"}
                        decimalScale={2}
                        thousandSeparator={false}
                        suffix={"%"}/>)
                    </>
         }
    }
    let afrrate:number = ((common && common.afrrate)*100) || 0;
        return (<Grid container spacing={3} className="mt20">
                <Grid item xs={12} md={8}>
                    <Typography component="div" className="txtGray f12 floatLeft w100">
                        <Typography component="div" className="txtGray f12 mb0" style={{lineHeight: '20px'}} ><b>Assumptions Used
                            for <StrategyName strategyName={strategyName}/> and Alternative Choices:</b>
                            <Tooltip
                                    color="primary"
                                    title="All assumptions are subject to change and are provided for illustrative purposes only. Actual results may be more or less favorable. This presentation is not valid unless accompanied by a complete insurance company illustration. Please see the full illustration for guaranteed values and other important information."
                                    arrow>
                                <IconButton className="pl0 pr0 w15" aria-label="Info">
                                    <InfoIcon className="f18"/>
                                </IconButton>
                            </Tooltip>
                            {clientInvestment} allocated to {getAllocations()}
                        </Typography>
                        <Typography className="txtGray f12 mb0" style={{ lineHeight: "20px" }}>IUL insurance policy
                            distributions begin at the latter of age 65 or after the lender loan has been repaid
                            (typically in the 15th policy year) and continue through age 90.</Typography>
                        <Typography className="txtGray f12 mb0" style={{lineHeight: '20px'}}>Long Term Capital Gains Rate of {capitalgainstaxrate}%.</Typography>
                        <Typography className="txtGray f12 mb0" style={{lineHeight: '20px'}}>Income tax rate of {incometaxrate}%.</Typography>
                        <Typography className="txtGray f12 mb0" style={{lineHeight: '20px'}}>Assumed asset management fee of {common && common.managementfee*100}%</Typography>
                        <Typography className="txtGray f12 mb0" style={{ lineHeight: "20px" }}>Participation in {strategyName} requires a minimum contribution amount of $21,350 annually, which includes the annual trust fees of
                            $1,350 and a portion of the IUL insurance policy premium. {strategyName} also requires a
                            participant trust to be established as part of the strategy. The total IUL insurance premium
                            is paid by the trust to the life insurer once you and the commercial lender contribute
                            sufficient funds to pay the IUL insurance policy premium to the trust.</Typography>

                        {(strategyName === "Tri-Zen") &&
                                <Typography component="strong" className="txtGray f12 mb0 floatLeft w100"
                                            style={{ lineHeight: "20px" }}>AFR Rate of {afrrate}%.
                                    <Tooltip arrow color="primary"
                                             title="The Applicable Federal Rate is the minimum regulatory interest rate that must be charged on split dollar loans. The interest is accumulated and repaid with the loan principle either at the insured death or the split dollar loan exit (typically shown two years after final distribution from the policy - e.g age 92 in most designs).  As the loan is a fixed duration loan due typically in 30 years plus, the long term AFR rate is assumed. The rate shown, is the rate used for the first contribution and is FIXED for the duration of the note.  Each contribution is treated as a new loan at the then prevailing AFR rate (i.e. each yearly contribution will be at the long term AFR rate at that time). For assumption purposes the design increases the AFR rate assumed on each new contribution. AFR rates are published monthly.">
                                        <IconButton aria-label="Info">
                                            <InfoIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>
                        }

                    </Typography>
                </Grid>
            </Grid>);

}

export default Assumptions;